module.exports = __webpack_public_path__ + "img/twiga_logo.545ead8c.png";